'use client';

import { cn, getColorwayWithTransparency, getYMargins } from '@/utils/styles';
import CardsVerticalScrollItem from './CardsVerticalScrollItem';
import { useRef } from 'react';
import { CardsVerticalScrollProps } from './types';
import { Colorways } from '@/types/constants';

const CardsVerticalScroll = ({
  sectionName,
  margins,
  transparentBackground,
  copyAlignment,
  cards,
}: CardsVerticalScrollProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const listWrapperRef = useRef<HTMLDivElement>(null);

  const internalClassNames = {
    wrapper: cn(
      'overflow-hidden',
      getYMargins(margins),
      getColorwayWithTransparency(Colorways.DarkGreenGradientLeftToRight, transparentBackground),
    ),
    list: cn('md:content-wrapper relative'),
  };

  return (
    <div ref={containerRef} id={sectionName} className={internalClassNames.wrapper}>
      <div ref={listWrapperRef} className={internalClassNames.list}>
        {(cards?.items ?? []).map((card, index) => (
          <CardsVerticalScrollItem
            key={`${card.sys.id}-${index}`}
            {...card}
            copyAlignment={copyAlignment}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default CardsVerticalScroll;
